/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const createRequestToPay = /* GraphQL */ `mutation CreateRequestToPay(
  $input: CreateRequestToPayInput!
  $condition: ModelRequestToPayConditionInput
) {
  createRequestToPay(input: $input, condition: $condition) {
    id
    orderID
    expirationTime
    createdAt
    saleID
    creator
    customerID
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateRequestToPayMutationVariables,
  APITypes.CreateRequestToPayMutation
>;
export const updateRequestToPay = /* GraphQL */ `mutation UpdateRequestToPay(
  $input: UpdateRequestToPayInput!
  $condition: ModelRequestToPayConditionInput
) {
  updateRequestToPay(input: $input, condition: $condition) {
    id
    orderID
    expirationTime
    createdAt
    saleID
    creator
    customerID
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateRequestToPayMutationVariables,
  APITypes.UpdateRequestToPayMutation
>;
export const deleteRequestToPay = /* GraphQL */ `mutation DeleteRequestToPay(
  $input: DeleteRequestToPayInput!
  $condition: ModelRequestToPayConditionInput
) {
  deleteRequestToPay(input: $input, condition: $condition) {
    id
    orderID
    expirationTime
    createdAt
    saleID
    creator
    customerID
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteRequestToPayMutationVariables,
  APITypes.DeleteRequestToPayMutation
>;
export const createSale = /* GraphQL */ `mutation CreateSale(
  $input: CreateSaleInput!
  $condition: ModelSaleConditionInput
) {
  createSale(input: $input, condition: $condition) {
    id
    username
    firstname
    lastname
    branch
    baskets {
      nextToken
      __typename
    }
    customers {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSaleMutationVariables,
  APITypes.CreateSaleMutation
>;
export const updateSale = /* GraphQL */ `mutation UpdateSale(
  $input: UpdateSaleInput!
  $condition: ModelSaleConditionInput
) {
  updateSale(input: $input, condition: $condition) {
    id
    username
    firstname
    lastname
    branch
    baskets {
      nextToken
      __typename
    }
    customers {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSaleMutationVariables,
  APITypes.UpdateSaleMutation
>;
export const deleteSale = /* GraphQL */ `mutation DeleteSale(
  $input: DeleteSaleInput!
  $condition: ModelSaleConditionInput
) {
  deleteSale(input: $input, condition: $condition) {
    id
    username
    firstname
    lastname
    branch
    baskets {
      nextToken
      __typename
    }
    customers {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSaleMutationVariables,
  APITypes.DeleteSaleMutation
>;
export const createBasket = /* GraphQL */ `mutation CreateBasket(
  $input: CreateBasketInput!
  $condition: ModelBasketConditionInput
) {
  createBasket(input: $input, condition: $condition) {
    id
    basketID
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateBasketMutationVariables,
  APITypes.CreateBasketMutation
>;
export const updateBasket = /* GraphQL */ `mutation UpdateBasket(
  $input: UpdateBasketInput!
  $condition: ModelBasketConditionInput
) {
  updateBasket(input: $input, condition: $condition) {
    id
    basketID
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateBasketMutationVariables,
  APITypes.UpdateBasketMutation
>;
export const deleteBasket = /* GraphQL */ `mutation DeleteBasket(
  $input: DeleteBasketInput!
  $condition: ModelBasketConditionInput
) {
  deleteBasket(input: $input, condition: $condition) {
    id
    basketID
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteBasketMutationVariables,
  APITypes.DeleteBasketMutation
>;
export const createAddress = /* GraphQL */ `mutation CreateAddress(
  $input: CreateAddressInput!
  $condition: ModelAddressConditionInput
) {
  createAddress(input: $input, condition: $condition) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateAddressMutationVariables,
  APITypes.CreateAddressMutation
>;
export const updateAddress = /* GraphQL */ `mutation UpdateAddress(
  $input: UpdateAddressInput!
  $condition: ModelAddressConditionInput
) {
  updateAddress(input: $input, condition: $condition) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateAddressMutationVariables,
  APITypes.UpdateAddressMutation
>;
export const deleteAddress = /* GraphQL */ `mutation DeleteAddress(
  $input: DeleteAddressInput!
  $condition: ModelAddressConditionInput
) {
  deleteAddress(input: $input, condition: $condition) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteAddressMutationVariables,
  APITypes.DeleteAddressMutation
>;
export const createTaxInvoiceAddress = /* GraphQL */ `mutation CreateTaxInvoiceAddress(
  $input: CreateTaxInvoiceAddressInput!
  $condition: ModelTaxInvoiceAddressConditionInput
) {
  createTaxInvoiceAddress(input: $input, condition: $condition) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    companyName
    companyBranch
    taxID
    isDefault
    requestTaxInvoice
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateTaxInvoiceAddressMutationVariables,
  APITypes.CreateTaxInvoiceAddressMutation
>;
export const updateTaxInvoiceAddress = /* GraphQL */ `mutation UpdateTaxInvoiceAddress(
  $input: UpdateTaxInvoiceAddressInput!
  $condition: ModelTaxInvoiceAddressConditionInput
) {
  updateTaxInvoiceAddress(input: $input, condition: $condition) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    companyName
    companyBranch
    taxID
    isDefault
    requestTaxInvoice
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateTaxInvoiceAddressMutationVariables,
  APITypes.UpdateTaxInvoiceAddressMutation
>;
export const deleteTaxInvoiceAddress = /* GraphQL */ `mutation DeleteTaxInvoiceAddress(
  $input: DeleteTaxInvoiceAddressInput!
  $condition: ModelTaxInvoiceAddressConditionInput
) {
  deleteTaxInvoiceAddress(input: $input, condition: $condition) {
    id
    customerID
    address
    district
    email
    firstname
    lastname
    name
    phone
    postcode
    subDistrict
    province
    location {
      lat
      lng
      __typename
    }
    companyName
    companyBranch
    taxID
    isDefault
    requestTaxInvoice
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteTaxInvoiceAddressMutationVariables,
  APITypes.DeleteTaxInvoiceAddressMutation
>;
export const createCustomer = /* GraphQL */ `mutation CreateCustomer(
  $input: CreateCustomerInput!
  $condition: ModelCustomerConditionInput
) {
  createCustomer(input: $input, condition: $condition) {
    id
    customerID
    email
    firstname
    lastname
    address {
      nextToken
      __typename
    }
    taxInvoice {
      nextToken
      __typename
    }
    phone_number
    basketID
    sales {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomerMutationVariables,
  APITypes.CreateCustomerMutation
>;
export const updateCustomer = /* GraphQL */ `mutation UpdateCustomer(
  $input: UpdateCustomerInput!
  $condition: ModelCustomerConditionInput
) {
  updateCustomer(input: $input, condition: $condition) {
    id
    customerID
    email
    firstname
    lastname
    address {
      nextToken
      __typename
    }
    taxInvoice {
      nextToken
      __typename
    }
    phone_number
    basketID
    sales {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomerMutationVariables,
  APITypes.UpdateCustomerMutation
>;
export const deleteCustomer = /* GraphQL */ `mutation DeleteCustomer(
  $input: DeleteCustomerInput!
  $condition: ModelCustomerConditionInput
) {
  deleteCustomer(input: $input, condition: $condition) {
    id
    customerID
    email
    firstname
    lastname
    address {
      nextToken
      __typename
    }
    taxInvoice {
      nextToken
      __typename
    }
    phone_number
    basketID
    sales {
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCustomerMutationVariables,
  APITypes.DeleteCustomerMutation
>;
export const createDraftOrder = /* GraphQL */ `mutation CreateDraftOrder(
  $input: CreateDraftOrderInput!
  $condition: ModelDraftOrderConditionInput
) {
  createDraftOrder(input: $input, condition: $condition) {
    id
    data
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDraftOrderMutationVariables,
  APITypes.CreateDraftOrderMutation
>;
export const updateDraftOrder = /* GraphQL */ `mutation UpdateDraftOrder(
  $input: UpdateDraftOrderInput!
  $condition: ModelDraftOrderConditionInput
) {
  updateDraftOrder(input: $input, condition: $condition) {
    id
    data
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateDraftOrderMutationVariables,
  APITypes.UpdateDraftOrderMutation
>;
export const deleteDraftOrder = /* GraphQL */ `mutation DeleteDraftOrder(
  $input: DeleteDraftOrderInput!
  $condition: ModelDraftOrderConditionInput
) {
  deleteDraftOrder(input: $input, condition: $condition) {
    id
    data
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteDraftOrderMutationVariables,
  APITypes.DeleteDraftOrderMutation
>;
export const createSaleStat = /* GraphQL */ `mutation CreateSaleStat(
  $input: CreateSaleStatInput!
  $condition: ModelSaleStatConditionInput
) {
  createSaleStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    totalCustomer
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSaleStatMutationVariables,
  APITypes.CreateSaleStatMutation
>;
export const updateSaleStat = /* GraphQL */ `mutation UpdateSaleStat(
  $input: UpdateSaleStatInput!
  $condition: ModelSaleStatConditionInput
) {
  updateSaleStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    totalCustomer
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSaleStatMutationVariables,
  APITypes.UpdateSaleStatMutation
>;
export const deleteSaleStat = /* GraphQL */ `mutation DeleteSaleStat(
  $input: DeleteSaleStatInput!
  $condition: ModelSaleStatConditionInput
) {
  deleteSaleStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    totalCustomer
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSaleStatMutationVariables,
  APITypes.DeleteSaleStatMutation
>;
export const createSaleCustomerStat = /* GraphQL */ `mutation CreateSaleCustomerStat(
  $input: CreateSaleCustomerStatInput!
  $condition: ModelSaleCustomerStatConditionInput
) {
  createSaleCustomerStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSaleCustomerStatMutationVariables,
  APITypes.CreateSaleCustomerStatMutation
>;
export const updateSaleCustomerStat = /* GraphQL */ `mutation UpdateSaleCustomerStat(
  $input: UpdateSaleCustomerStatInput!
  $condition: ModelSaleCustomerStatConditionInput
) {
  updateSaleCustomerStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSaleCustomerStatMutationVariables,
  APITypes.UpdateSaleCustomerStatMutation
>;
export const deleteSaleCustomerStat = /* GraphQL */ `mutation DeleteSaleCustomerStat(
  $input: DeleteSaleCustomerStatInput!
  $condition: ModelSaleCustomerStatConditionInput
) {
  deleteSaleCustomerStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    saleID
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSaleCustomerStatMutationVariables,
  APITypes.DeleteSaleCustomerStatMutation
>;
export const createCustomerStat = /* GraphQL */ `mutation CreateCustomerStat(
  $input: CreateCustomerStatInput!
  $condition: ModelCustomerStatConditionInput
) {
  createCustomerStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCustomerStatMutationVariables,
  APITypes.CreateCustomerStatMutation
>;
export const updateCustomerStat = /* GraphQL */ `mutation UpdateCustomerStat(
  $input: UpdateCustomerStatInput!
  $condition: ModelCustomerStatConditionInput
) {
  updateCustomerStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateCustomerStatMutationVariables,
  APITypes.UpdateCustomerStatMutation
>;
export const deleteCustomerStat = /* GraphQL */ `mutation DeleteCustomerStat(
  $input: DeleteCustomerStatInput!
  $condition: ModelCustomerStatConditionInput
) {
  deleteCustomerStat(input: $input, condition: $condition) {
    id
    timestamp
    granularity
    totalSaleVolume
    totalOrder
    productList
    orderList
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteCustomerStatMutationVariables,
  APITypes.DeleteCustomerStatMutation
>;
export const createOrderID = /* GraphQL */ `mutation CreateOrderID(
  $input: CreateOrderIDInput!
  $condition: ModelOrderIDConditionInput
) {
  createOrderID(input: $input, condition: $condition) {
    key
    counter
    lastEdited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateOrderIDMutationVariables,
  APITypes.CreateOrderIDMutation
>;
export const updateOrderID = /* GraphQL */ `mutation UpdateOrderID(
  $input: UpdateOrderIDInput!
  $condition: ModelOrderIDConditionInput
) {
  updateOrderID(input: $input, condition: $condition) {
    key
    counter
    lastEdited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateOrderIDMutationVariables,
  APITypes.UpdateOrderIDMutation
>;
export const deleteOrderID = /* GraphQL */ `mutation DeleteOrderID(
  $input: DeleteOrderIDInput!
  $condition: ModelOrderIDConditionInput
) {
  deleteOrderID(input: $input, condition: $condition) {
    key
    counter
    lastEdited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteOrderIDMutationVariables,
  APITypes.DeleteOrderIDMutation
>;
export const createSaleCustomers = /* GraphQL */ `mutation CreateSaleCustomers(
  $input: CreateSaleCustomersInput!
  $condition: ModelSaleCustomersConditionInput
) {
  createSaleCustomers(input: $input, condition: $condition) {
    id
    saleID
    customerID
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSaleCustomersMutationVariables,
  APITypes.CreateSaleCustomersMutation
>;
export const updateSaleCustomers = /* GraphQL */ `mutation UpdateSaleCustomers(
  $input: UpdateSaleCustomersInput!
  $condition: ModelSaleCustomersConditionInput
) {
  updateSaleCustomers(input: $input, condition: $condition) {
    id
    saleID
    customerID
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateSaleCustomersMutationVariables,
  APITypes.UpdateSaleCustomersMutation
>;
export const deleteSaleCustomers = /* GraphQL */ `mutation DeleteSaleCustomers(
  $input: DeleteSaleCustomersInput!
  $condition: ModelSaleCustomersConditionInput
) {
  deleteSaleCustomers(input: $input, condition: $condition) {
    id
    saleID
    customerID
    sale {
      id
      username
      firstname
      lastname
      branch
      createdAt
      updatedAt
      __typename
    }
    customer {
      id
      customerID
      email
      firstname
      lastname
      phone_number
      basketID
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteSaleCustomersMutationVariables,
  APITypes.DeleteSaleCustomersMutation
>;
